export const REVENUE_OPTIONS = [
  { value: "0-100000", label: "Under $100K" },
  { value: "100000-500000", label: "$100K - $500K" },
  { value: "500000-1000000", label: "$500K - $1M" },
  { value: "1000000-5000000", label: "$1M - $5M" },
  { value: "5000000-999999999", label: "$5M+" },
];

export const EMPLOYEE_OPTIONS = [
  { value: "1-5", label: "1-5" },
  { value: "6-20", label: "6-20" },
  { value: "21-50", label: "21-50" },
  { value: "51-200", label: "51-200" },
  { value: "200-9999", label: "200+" },
];

export const RATING_OPTIONS = [
  { value: "0", label: "Any" },
  { value: "3", label: "3+" },
  { value: "3.5", label: "3.5+" },
  { value: "4", label: "4+" },
  { value: "4.5", label: "4.5+" },
];
